import Glide from "@glidejs/glide";

class HeroSlider {
  constructor() {
    const config = {
      type: "carousel",
      startAt: 0,
      perView: 1,
      autoplay: 5000,
    };
    new Glide(".glide", config).mount();
  }
}

export default HeroSlider;
